/**
 * Zentrale deutsche UI-Strings. Phase-2-Stub für i18n — die Struktur
 * spiegelt die spaetere `t(key, vars?)`-Funktion bereits wider, damit ein
 * Umbau auf next-intl o.ae. nicht jeden Komponenten anfasst.
 */
export const strings = {
  common: {
    loading: 'Einen Moment …',
    yes: 'Ja',
    no: 'Nein',
    notSpecified: '—',
  },
  landing: {
    headline: '37Sekunden',
    subline:
      'Bewerbungen in 37 Sekunden — transparent, fair, mobil. Der schnellste Weg in den nächsten Job.',
    portalHintTitle: 'Du hast bereits eine Bewerbung eingereicht?',
    portalHintBody:
      'Den Link zu deinem persönlichen Boarding-Pass findest du in der Empfangsbestätigung per E-Mail. Tippe ihn dort an, um den aktuellen Stand zu sehen.',
  },
  portal: {
    journeyHeading: 'Deine Reise',
    fieldsHeading: 'Was Du uns mitgegeben hast',
    documentsHeading: 'Deine Unterlagen',
    loadingHint: 'Wir holen Deinen Boarding-Pass …',
    boardingPass: {
      titleApplicant: 'Bewerber:in',
      titleApplicantFallback: 'Bewerber:in',
      ticketLabel: 'Ticket-Nr.',
      jobLabel: 'Stelle',
      locationLabel: 'Standort',
      submittedLabel: 'Eingereicht am',
      qrPlaceholderTitle: 'Dein QR-Code',
      qrPlaceholderBody:
        'Den QR-Code findest du in deiner Empfangsbestätigungs-Mail.',
      tenantLabel: 'Unternehmen',
    },
    journey: {
      stageReachedAt: 'Erreicht am',
      currentStage: 'Aktuelle Station',
      pendingStage: 'Ausstehend',
      terminalStage: 'Endpunkt',
    },
    documents: {
      empty: 'Hier erscheinen Deine Unterlagen, sobald Du welche hochlädst.',
      uploadedAt: 'Hochgeladen',
    },
    fields: {
      empty: 'Du hast noch keine Angaben hinterlegt.',
      sectionFallback: 'Allgemeine Angaben',
    },
    withdraw: {
      title: 'Du kannst deine Bewerbung jederzeit zurückziehen',
      body: 'Auf Wunsch entfernen wir deine Bewerbung aus dem laufenden Prozess. Wir bestätigen den Widerruf per E-Mail.',
      cta: 'Bewerbung zurückziehen',
      ctaHint: '(Funktion folgt in Kürze)',
    },
    footer: {
      help: 'Brauchst Du etwas?',
    },
  },
  notFound: {
    title: 'Akte nicht gefunden',
    body: 'Bitte prüfe Deinen Link oder öffne ihn aus Deiner letzten E-Mail von uns erneut.',
  },
  errorBoundary: {
    title: 'Da ist etwas schiefgelaufen',
    body: 'Wir konnten Deinen Boarding-Pass gerade nicht laden. Bitte versuche es in einem Moment erneut.',
    retry: 'Erneut versuchen',
  },
} as const;

export type Strings = typeof strings;
